var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserMedia',{attrs:{"index":_vm.index,"rowData":_vm.userMediaRowData,"value":_vm.userMediaValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }